import { useState, useEffect } from "react";
import RoleEdit from "./edit/index";
import { RoleHistory } from "./history/index";
import { PageTabs } from "@/components/ui/page-tabs";
import { useParams, useSearchParams } from "react-router";

const Details = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");

  const [activeTab, setActiveTab] = useState<"details" | "history">("details");

  useEffect(() => {
    if (type === "history") {
      setActiveTab("history");
    }
  }, [type]);

  return (
    <div className="flex flex-col gap-3 tablet:gap-4 laptop:gap-6 desktop:gap-8">
      <PageTabs
        tabs={[
          { label: "Detalles", key: "details" },
          { label: "Historial", key: "history" },
        ]}
        activeKey={activeTab}
        onTabChange={(key) => {
          setActiveTab(key as "details" | "history");
        }}
      ></PageTabs>
      {activeTab === "details" && <RoleEdit />}
      {activeTab === "history" && <RoleHistory roleId={id} />}
    </div>
  );
};

export default Details;
